<template lang="pug">
  // E-mail変更受付完了
  #change-mail-form-reception
    b-container(fluid="fluid")
      .mail-box.mx-auto.justify-content-center.text-center
        b-form-text.mt-3.text-left.white-space.description-font-size {{text_content}}
        b-table-simple.mt-4.mb-4.rounded(responsive="responsive", bordered)
          b-tbody
            b-tr
              b-th.alert-secondary.mail-label メールアドレス
              b-td.text-left.mail-break {{mail_address}}
        b-form-text.mb-3.text-left.white-space.text_caution {{text_caution}}
        router-link(:to="{name: 'ShowCustomerInfo'}") お客様情報確認画面へ
</template>

<script>
export default {
  name: "ChangeMailFormReception",
  props: {
    p_mail_address: { type: String, required: false},
  },
  created() {
    // 直接画面に遷移した場合
    if (this.p_mail_address === undefined) {
      // メール変更画面に戻す
      this.$router.push({name: "ChangeMail"})
    }
  },
  data() {
    return {
      customer_title_col_class: "py-2 px-2 border-right font-weight-bold table-title-col-width",
      customer_data_col_class: "py-2 px-2",
      mail_address: this.p_mail_address,

      text_content: "下記のメールアドレスへメールアドレス変更URLを記載した\n"
          + "件名「メールアドレス変更画面へのご案内」\n"
          + "メールを送信いたしました。",

      text_caution: "※メールに記載されている「メールアドレス変更URL」をクリックしていただくことで、\n"
          + "　登録完了となります。\n"
          + "※メール送信後、24時間を超過しますと、セキュリティ保持のため有効期限切れとなります。\n"
          + "　その場合は再度、最初からお手続きをお願いいたします。",
    }
  }
}
</script>

<style scoped>
.mail-box {
  width: 600px;
}
.mail-label {
  width: 200px;
  white-space: nowrap;
  vertical-align: middle;
}
.mail-break {
  word-break: break-all;
}
.white-space {
  white-space: pre-wrap;
}
.description-font-size {
  font-size: 16px;
}
.text_caution {
  font-size: smaller;
  color: red !important;
}
</style>